module.exports = {
	
	//sounds are loaded separately with super-mega-polished library which handles many different browsers starting even on loading stage:
	howler:	[

	],
	
	//all other different resources (even those which configure the game logic) are able to be loaded with PIXI native loader:
	pixi: [
		'res/screen.png',
        'res/chip_black.png',
        'res/chip_white.png',

        'res/chips_and_backgrounds.json',
        'res/avatars.json',
        'res/dice_black_0.json',
        'res/dice_black_1.json',
        'res/dice_white_0.json',
        'res/dice_white_1.json',
        'res/lighting_cell_0.json',
        'res/lighting_cell_1.json',
        'res/undo_button.json',
	]
};




//////////////////
// WEBPACK FOOTER
// ./res/resources.js
// module id = 29
// module chunks = 0